import type { PageLoad } from './$types';
import type { PageData } from '$lib/metadataTypes/MetaTypes';

export const load: PageLoad = async ({ parent }): Promise<PageData> => {
  const { site, category } = await parent(); // parent() = CategoryData

  return {
    site,
    category,
    page: {
			title: "Defining Properties",
description: "Learn how to define properties in Freon language structures, including primitive, part, reference, and optional properties, and how containment and references work in the metamodel.",
tags: [ "properties", "primitive properties", "part properties", "reference properties", "optional properties", "language structure", "metamodel", "Freon", "DSL development"] ,
modifiedTime: "2025-11-07T17:39:02.325Z",
publishedTime: "2025-11-07T17:20:18.610Z"
    }
  };
};